/**
 * API origin resolver.
 *
 * On Emergent Platform (both preview and production), the FastAPI backend
 * and React frontend are served from the SAME origin (kubernetes ingress
 * routes /api/* to the backend, everything else to the frontend).
 *
 * So we always call same-origin, which:
 *   - eliminates CORS preflight headaches
 *   - works for cleany.dk in production
 *   - works for *.preview.emergentagent.com in preview
 *   - keeps httpOnly cookies working (set on the same domain as the page)
 *
 * `REACT_APP_BACKEND_URL` is only used as a hard override for local dev
 * (when running webpack-dev-server on localhost:3000 against an external
 * backend).
 */
export const apiOrigin = (() => {
    if (typeof window === "undefined") {
        return process.env.REACT_APP_BACKEND_URL || "";
    }
    const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";
    if (isLocalhost && process.env.REACT_APP_BACKEND_URL) {
        return process.env.REACT_APP_BACKEND_URL;
    }
    return window.location.origin;
})();
